module.exports = __webpack_public_path__ + "media/images/email-icon-394db3b3402d6fb4a05a1334abf21f1e.png";